export const CUSTOMER_PROFILE_PATH = '/customer/profile';
export const CUSTOMER_NOTIFICATIONS_PATH = '/customer/notifications';
export const CUSTOMER_AGENTS_PATH = '/customer/agents';
export const CUSTOMER_DATA_USAGE_PATH = '/customer/data-usage';
export const CUSTOMER_SSO_PATH = '/customer/sso';
export const CUSTOMER_SSO_ADD_PATH = '/customer/sso/add';
export const CUSTOMER_SSO_EDIT_PATH = '/customer/sso/:configId/edit';
export const CUSTOMER_SAML_PATH = '/customer/saml';
export const CUSTOMER_MFA_PATH = '/customer/mfa';
export const CUSTOMER_CUSTOMIZATIONS_PATH = '/customer/customizations';
export const CUSTOMER_PLAN_USAGE_PATH = '/customer/plan-usage';

export const CUSTOMER_INTEGRATIONS_PATH = '/customer/integrations';
export const CUSTOMER_INTEGRATION_ERP_PATH = '/customer/integrations/erp';

export const CUSTOMER_API_INTEGRATIONS_PATH = '/customer/integrations/api-integrations';
export const CUSTOMER_API_INTEGRATIONS_ADD_PATH = '/customer/integrations/api-integrations/add';
export const CUSTOMER_API_INTEGRATIONS_EDIT_PATH = '/customer/integrations/api-integrations/:integrationId/edit';

export const CUSTOMER_INTEGRATION_SFTP_PUBLIC_KEYS_PATH = '/customer/integrations/sftp-public-keys';

export const CUSTOMER_INTEGRATION_OUTLOOK_PATH = '/customer/integrations/outlook';
export const CUSTOMER_INTEGRATION_OUTLOOK_ADD_PATH = '/customer/integrations/outlook/add';
export const CUSTOMER_INTEGRATION_OUTLOOK_EDIT_PATH = '/customer/integrations/outlook/:integrationId/edit';

export const CUSTOMER_INTEGRATION_WECLAPP_PATH = '/customer/integrations/weclapp';
export const CUSTOMER_INTEGRATION_WECLAPP_ADD_PATH = '/customer/integrations/weclapp/add';
export const CUSTOMER_INTEGRATION_WECLAPP_EDIT_PATH = '/customer/integrations/weclapp/:integrationId/edit';

export const CUSTOMER_INTEGRATION_SAGE100_PATH = '/customer/integrations/sage100';
export const CUSTOMER_INTEGRATION_SAGE100_ADD_PATH = '/customer/integrations/sage100/add';
export const CUSTOMER_INTEGRATION_SAGE100_EDIT_PATH = '/customer/integrations/sage100/:integrationId/edit';
export const CUSTOMER_INTEGRATION_SAGE100_OAUTH2_CALLBACK_PATH = '/customer/integrations/sage100/oauth2/callback';

export const CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_PATH = '/customer/integrations/microtech_buero_plus';
export const CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_ADD_PATH = '/customer/integrations/microtech_buero_plus/add';
export const CUSTOMER_INTEGRATION_MICROTECH_BUERO_PLUS_EDIT_PATH =
    '/customer/integrations/microtech_buero_plus/:integrationId/edit';

export const CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_PATH = '/customer/integrations/dynamicsfinanceoperations';
export const CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_ADD_PATH =
    '/customer/integrations/dynamicsfinanceoperations/add';
export const CUSTOMER_INTEGRATION_DYNAMICS_FINANCE_OPERATIONS_EDIT_PATH =
    '/customer/integrations/dynamicsfinanceoperations/:integrationId/edit';

export const CUSTOMER_INTEGRATION_NETSUITE_PATH = '/customer/integrations/netsuite';
export const CUSTOMER_INTEGRATION_NETSUITE_ADD_PATH = '/customer/integrations/netsuite/add';
export const CUSTOMER_INTEGRATION_NETSUITE_EDIT_PATH = '/customer/integrations/netsuite/:integrationId/edit';

export const CUSTOMER_INTEGRATION_ORDERWISE_PATH = '/customer/integrations/orderwise';
export const CUSTOMER_INTEGRATION_ORDERWISE_ADD_PATH = '/customer/integrations/orderwise/add';
export const CUSTOMER_INTEGRATION_ORDERWISE_EDIT_PATH = '/customer/integrations/orderwise/:integrationId/edit';

export const CUSTOMER_INTEGRATION_ORDAT_PATH = '/customer/integrations/ordat';
export const CUSTOMER_INTEGRATION_ORDAT_ADD_PATH = '/customer/integrations/ordat/add';
export const CUSTOMER_INTEGRATION_ORDAT_EDIT_PATH = '/customer/integrations/ordat/:integrationId/edit';

export const CUSTOMER_INTEGRATION_ALPHAPLAN_PATH = '/customer/integrations/alphaplan';
export const CUSTOMER_INTEGRATION_ALPHAPLAN_ADD_PATH = '/customer/integrations/alphaplan/add';
export const CUSTOMER_INTEGRATION_ALPHAPLAN_EDIT_PATH = '/customer/integrations/alphaplan/:integrationId/edit';

export const CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_PATH = '/customer/integrations/sage200professional';
export const CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_ADD_PATH = '/customer/integrations/sage200professional/add';
export const CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_EDIT_PATH =
    '/customer/integrations/sage200professional/:integrationId/edit';
export const CUSTOMER_INTEGRATION_SAGE200PROFESSIONAL_OAUTH2_CALLBACK_PATH =
    '/customer/integrations/sage200professional/oauth2/callback';

export const CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_PATH = '/customer/integrations/business-central';
export const CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_ADD_PATH = '/customer/integrations/business-central/add';
export const CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_EDIT_PATH =
    '/customer/integrations/business-central/:integrationId/edit';
export const CUSTOMER_INTEGRATION_BUSINESS_CENTRAL_SETUP_DATA_PATH =
    '/customer/integrations/business-central/:integrationId/setup-data';

export const CUSTOMER_INTEGRATION_SMART_INBOX_PATH = '/customer/integrations/smartinbox';
export const CUSTOMER_INTEGRATION_SMART_INBOX_CONFIG_PATH =
    '/customer/integrations/smartinbox/:integrationId/config/:tab?/:productType?';
export const CUSTOMER_SMART_INBOX_CATEGORY_EDIT_PATH =
    '/customer/integrations/smartinbox/:integrationId/config/:tab?/:productType?/:categoryId/edit';

export const CUSTOMER_INTEGRATION_QUICKBOOKS_PATH = '/customer/integrations/quickbooks';
export const CUSTOMER_INTEGRATION_QUICKBOOKS_ADD_PATH = '/customer/integrations/quickbooks/add';
export const CUSTOMER_INTEGRATION_QUICKBOOKS_EDIT_PATH = '/customer/integrations/quickbooks/:integrationId/edit';

export const CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_PATH = '/customer/integrations/sapbusinessone';
export const CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_ADD_PATH = '/customer/integrations/sapbusinessone/add';
export const CUSTOMER_INTEGRATION_SAP_BUSINESS_ONE_EDIT_PATH =
    '/customer/integrations/sapbusinessone/:integrationId/edit';

export const CUSTOMER_INTEGRATION_CUSTOM_PATH = '/customer/integrations/customintegration';
export const CUSTOMER_INTEGRATION_CUSTOM_ADD_PATH = '/customer/integrations/customintegration/add';
export const CUSTOMER_INTEGRATION_CUSTOM_EDIT_PATH = '/customer/integrations/customintegration/:integrationId/edit';

export const CUSTOMER_INTEGRATION_SHAREPOINT_PATH = '/customer/integrations/sharepoint';
export const CUSTOMER_INTEGRATION_SHAREPOINT_CONNECT_PATH = '/customer/integrations/sharepoint/connect';

export const CUSTOMER_INTEGRATION_WEBHOOK_PATH = '/customer/integrations/webhooks';
export const CUSTOMER_INTEGRATION_WEBHOOK_ADD_PATH = '/customer/integrations/webhooks/add';
export const CUSTOMER_INTEGRATION_WEBHOOK_EDIT_PATH = '/customer/integrations/webhooks/:integrationId/edit';
